﻿import { defineStore } from 'pinia'
import { formatDate, isSuccess } from '@jms/utils'
import { useAuthStore } from './auth'
import { dictService } from '@jms/api'
type WrongTypes = {
  /**1涓婁紶鍥剧墖 */
  dictValueExtra3?: '1' | '0'
  /**鍚嶇О */
  dictValueExtra4: string
  /**key */
  dictKey: string
  children: WrongTypes[]
}
interface State {
  isBind: boolean
  getSiteTime: number
  siteList: {
    networkName: string
    networkCode: string
    parentNetworkCode: string
  }[]
  wrongTypes: WrongTypes[]
}
//鍏ㄥ眬鏁版嵁瀛樺偍
export const useSysDataStore = defineStore('sysData', {
  state: (): State => ({
    /**缁戝畾鐘舵€?榛樿true */
    isBind: true,
    /**鑾峰彇鎵€鏈夌珯鐐规椂闂?*/
    getSiteTime: new Date('2018-01-01 00:00:00').getTime(),
    /**鎵€鏈夌珯鐐规暟鎹?*/
    siteList: [],
    /**闂浠堕敊璇被鍨?*/
    wrongTypes: [] as any
  }),
  getters: {
    /**鑾峰彇褰撳墠閫変腑閿欒绫诲瀷瀵硅薄 */
    getProblemObjByCodes: (state) => {
      return (questionCodes: any[]) => {
        let obj = {} as WrongTypes
        if (questionCodes && questionCodes.length) {
          const findFirstItem = state.wrongTypes.find((_) => _.dictKey === questionCodes[0])
          if (findFirstItem) {
            obj = findFirstItem.children.find((_) => _.dictKey === questionCodes[1]) as WrongTypes
          }
        }
        return obj
      }
    }
  },
  actions: {
    getBindStatus() {
      const authStore = useAuthStore()
      return authStore.userInfo?.isCheckJt && authStore.userInfo?.isCheckJt?.id !== 'NO'
    },
    /**鑾峰彇鎵€鏈夌珯鐐规暟鎹?*/
    async getSiteList() {
      const res = await dictService.getNextSite({ dateTime: encodeURIComponent(this.getSiteTime) })
      if (!isSuccess(res)) return
      this.getSiteTime = this.siteList.length ? new Date().getTime() : this.getSiteTime
      this.siteList = this.siteList.concat(res.data ?? [])
    },
    /**闂浠?鑾峰彇閿欒绫诲瀷 */
    async getWrongList() {
      const res = await dictService.getWrongList()
      if (!isSuccess(res)) return
      const arr = []
      for (const key in res?.data) {
        if (Object.prototype.hasOwnProperty.call(res?.data, key)) {
          const item = res?.data[key]
          arr.push({ dictKey: key, dictValueExtra4: key, children: item })
        }
      }
      this.wrongTypes = arr
    }
  },
  persist: {
    storage: localStorage,
    paths: ['getSiteTime', 'siteList']
  }
})
